import Modal from '../../modal'
import HTML from '../../html'
import sharedData from '../../shared-data'

export default class PropertyVisning {
    constructor(blockRoot) {
        this.root = blockRoot

        $.ajax({
            method: "POST",
            url: window.wpEnvironment.ajaxurl,
            data: {
                action: "getPropertyVisningEvents",
                wpid: this.root.data("property-wpid"),
                proptype: this.root.data("proptype")
            },
            success: data => {
                // console.log(data);
                if (data.success && data.payload !== "undefined") {
                    this.root.empty()
                    this.root.append(data.payload.html)

                    this.buttons = {
                        showroom: this.root.find(".visning__event__link.showroom"),
                        calendar: this.root.find(".visning__event__link.calendar"),
                        contact: this.root.find('.contact-link-anchor'),
                    }

                    this.mapRoot = HTML("div").classes("map-root rmodal-inner-container").render()
                    this.showroomLocation = {
                        lat: this.buttons.showroom.data("showroom-latitude"),
                        lng: this.buttons.showroom.data("showroom-longitude")
                    }

                    this.showroomModal = new Modal()
                    this.showroomModal.defineContent(this.mapRoot)

                    this.showroomModal.on("show:end", modal => {
                        sharedData.googleMap.loadAssetsAsync(() => this._createMap())
                    })

                    this.buttons.showroom.on("click", event => {
                        event.preventDefault()
                        this._clearMap()
                        this.showroomModal.show()
                    })

                    this.buttons.contact.on('click', (event) => {
                        event.preventDefault()
                        let section = $('.prop-contact')

                        let hheight = $('.info-tabs__nav').outerHeight()
                        $('html, body').animate({
                            scrollTop: section.offset().top - hheight - 20,
                        })
                    })

                    if (window.addtocalendar !== "undefined") {
                        window.addtocalendar.load()
                    }
                }
            },
            complete: (jqXHR) => {
                // console.log(jqXHR);
            }
        })
    }

    _clearMap() {
        $(this.mapRoot).empty()
        return this
    }

    _createMap() {
        if (!sharedData.googleMap.JSAPIEmbedded) return
        var gmap = new google.maps.Map(this.mapRoot, {
            styles: sharedData.googleMap.style,
            zoom: 12,
            center: this.showroomLocation
        })

        var infoWindow = new google.maps.InfoWindow({
            content: HTML("h4").content("Hello maps!").render()
        })

        var gmarker = new google.maps.Marker({
            position: this.showroomLocation,
            map: gmap,
            animation: google.maps.Animation.DROP,
            icon: sharedData.googleMap.projektIcon
        })

        gmarker.addListener("click", () => {
            infoWindow.open(gmap, gmarker)
        })
    }
}

